var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { wrapDispatch } from "../Multireducer";
import { NeedAuthorization } from "../Auth";
import { I18NLink, I18NMenu, t, Translate } from "../I18N";
import { processFilters, encodeSearch } from "../Library/actions/libraryActions";
import { showSemanticSearch as showSemanticSearchAction } from "../SemanticSearch/actions/actions";
import { FeatureToggleSemanticSearch } from "../SemanticSearch/components/FeatureToggleSemanticSearch";
import { libraryViewInfo } from "./libraryViewInfo";
import { Icon } from "../UI";
import { actions } from "../BasicReducer";

import { searchParamsFromLocationSearch } from "../utils/routeHelpers";
import { DropdownMenu } from "./DropdownMenu";







const mapStateToProps = (state) => {
  const { user, settings, library } = state;
  return {
    user,
    librarySearch: library.search,
    libraryFilters: library.filters,
    links: settings.collection.get('links'),
    defaultLibraryView: settings.collection.get('defaultLibraryView'),
    privateInstance: settings.collection.get('private')
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    showSemanticSearch: showSemanticSearchAction,
    setSidePanelView: actions.set.bind(null, 'library.sidepanel.view')
  },
  wrapDispatch(dispatch, 'library')
);

const connector = connect(mapStateToProps, mapDispatchToProps);



const MenuComponent = ({
  librarySearch,
  libraryFilters,
  user,
  className,
  toggleMobileMenu,
  setSidePanelView,
  showSemanticSearch,
  links = fromJS([]),
  defaultLibraryView = 'cards',
  privateInstance
}) => {
  const hideMobileMenu = () => toggleMobileMenu(false);

  const getLink = (
  to,
  text,
  icon,
  linkClassName,
  onclick) => /*#__PURE__*/


  _jsx(I18NLink, {
    to: to,
    onClick: (args) => {
      if (onclick) onclick(args);
      hideMobileMenu();
    },
    className: `menuNav-btn btn btn-default ${linkClassName}`,
    activeclassname: "active-link",
    "aria-label": t('System', text, null, false) }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: icon }), /*#__PURE__*/
  _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, text)
  )
  );


  const libraryUrl = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();
    const searchParams = searchParamsFromLocationSearch(location, 'q') || {};
    const searchTerm = searchParams.searchTerm || '';
    const newParams = processFilters(librarySearch, libraryFilters.toJS());
    newParams.searchTerm = searchTerm;

    // @ts-ignore
    return `/${libraryViewInfo[defaultLibraryView].url}/${encodeSearch(newParams)}`;
  };

  const currentUser = user.toJS();

  const navLinks = links.
  map((link, index) => {
    if (link === undefined) {
      return null;
    }
    const type = link.get('type') || 'link';

    if (type === 'link') {
      const url = link.get('url') || '/';
      if (url.startsWith('http')) {
        return (/*#__PURE__*/
          _jsx("li", { className: "menuNav-item" }, link.get('_id'), /*#__PURE__*/
          _jsx("a", { href: url, className: "btn menuNav-btn", target: "_blank", rel: "noreferrer" }, void 0,
          t('Menu', link.get('title'))
          )
          ));

      }
      return (/*#__PURE__*/
        _jsx("li", { className: "menuNav-item" }, link.get('_id'), /*#__PURE__*/
        _jsx(I18NLink, {
          to: url,
          className: "btn menuNav-btn",
          activeclassname: "active-link",
          onClick: hideMobileMenu }, void 0,

        t('Menu', link.get('title'))
        )
        ));

    }

    return (/*#__PURE__*/
      _jsx(DropdownMenu, {
        link: fromJS(link.toJS()),
        position: index,

        hideMobileMenu: hideMobileMenu }, index
      ));

  }).
  filter((v) => v !== null).
  toArray();

  const setLibraryView = () => {
    setSidePanelView('library');
  };
  return (/*#__PURE__*/
    _jsx("ul", { className: className }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuItems" }, void 0, /*#__PURE__*/
    _jsx("ul", { className: "menuNav-list" }, void 0, navLinks)
    ), /*#__PURE__*/
    _jsx(I18NMenu, {}), /*#__PURE__*/
    _jsx("li", { className: "menuActions mobile-menuActions" }, void 0, /*#__PURE__*/
    _jsx("ul", { className: "menuNav-list" }, void 0, /*#__PURE__*/
    _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item semantic-search" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: showSemanticSearch,
      className: "menuNav-btn btn btn-default",
      "aria-label": t('System', 'Semantic search', null, false) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "flask" }), /*#__PURE__*/
    _jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Semantic search")
    )
    )
    )
    ),
    (!privateInstance || privateInstance === true && currentUser._id) && /*#__PURE__*/
    _jsx("li", { className: "menuNav-item" }, void 0,
    getLink(
      libraryUrl(),
      'Library',
      //@ts-ignore
      libraryViewInfo[defaultLibraryView].icon,
      'public-documents',
      setLibraryView
    )
    ), /*#__PURE__*/

    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item only-desktop" }, void 0,
    getLink('/settings/account', 'Settings', 'cog', 'settings-section')
    )
    ), /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item only-mobile" }, void 0,
    getLink('/settings', 'Settings', 'cog', 'settings-section')
    )
    ), /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item only-mobile" }, void 0, /*#__PURE__*/
    _jsx("a", { href: "/logout", className: "menuNav-btn btn btn-default" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "power-off" }), /*#__PURE__*/
    _jsx("span", { className: "tab-link-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Logout")
    )
    )
    )
    ),
    (() => {
      if (!currentUser._id) {
        return /*#__PURE__*/_jsx("li", { className: "menuNav-item" }, void 0, getLink('/login', 'Sign in', 'power-off'));
      }
      return null;
    })()
    )
    )
    ));

};

const container = connector(MenuComponent);
export { container as Menu };